/** The Intercom messenger's fixed numbers (NG-3452), in one place. */

/** The widget script, followed by the app ID the token endpoint returns. */
export const INTERCOM_WIDGET_URL = "https://widget.intercom.io/widget/";

/** Intercom's longest messenger session, 7 days. Ours is the NextGen sign-in's
 *  remaining time when that is shorter. */
export const INTERCOM_MAX_SESSION_MS = 604_800_000;

/** How long a "Chat with us" click waits for a messenger still starting before
 *  it says chat isn't available. */
export const OPEN_WAIT_MS = 8_000;

/** How long a token is used before a fresh one is fetched. Keep it below the
 *  backend's `TOKEN_TTL` (one hour, `cognota/intercom/token.py`). */
export const TOKEN_REFRESH_MS = 50 * 60_000;

/** The shortest gap between token refreshes, however little sign-in time is left. */
export const MIN_REFRESH_MS = 30_000;

/** The channel every open NextGen tab listens on for "chat ended". */
export const CHAT_SESSION_CHANNEL = "cognota-intercom";
